<template>
  <div
    data-test="search-input"
    :class="['bg-base relative flex flex-grow justify-items-end rounded-full', borderClass]"
  >
    <input
      ref="inputRef"
      type="search"
      :placeholder="placeholder"
      :value="modelValue"
      :aria-label="`${label} input`"
      :class="['inline-block rounded-l-full border-none bg-transparent pl-4 text-base', placeholderClass]"
      style="box-shadow: none"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown="$emit('keydown', $event)"
    />
    <component
      :is="clickable ? 'button' : 'span'"
      :class="{ 'cursor-pointer': clickable }"
      class="flex h-full w-10 items-center p-2"
      :aria-label="label"
      data-test="search-button"
      @click="$emit('click', $event)"
    >
      <InlineSvg
        path="icons/search"
        aria-hidden="true"
        class="text-important hover:text-important-hover h-6 w-6 flex-shrink-0"
      />
    </component>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { InlineSvg } from 'vue_features/shared/components/ui'

export default {
  name: 'SearchInput',
  components: { InlineSvg },
  inheritAttrs: false,
  props: {
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    placeholderClass: { type: String, default: '' },
    borderClass: { type: String, default: '' },
    modelValue: { type: String, default: '' },
  },
  setup(_, { attrs }) {
    const inputRef = ref()
    return {
      inputRef,
      clickable: computed(() => attrs.onClick !== undefined),
      focus: () => inputRef.value.focus(),
      blur: () => inputRef.value.blur(),
    }
  },
}
</script>

<style scoped>
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
  -webkit-appearance: none;
}
</style>
